import React, { Component } from 'react'
import {
  MessageComponentProps,
  MessageBubble,
  MessageBubbleText,
  FirebaseMessage
} from '@deal/chat-firebase'
import { Image } from '@deal/components'
import { Link } from 'react-router-dom'
import { formatMonetaryAmountAsJsx } from '#src/services/money'
import { truncate } from 'lodash'
import { ExpertCuratedOrderRichCardComponent, MessageRichCardType } from '#src/generated/graphql'
import styles from './styles.css'

export default class ServiceCuration extends Component<MessageComponentProps> {
  public static handlesMessage(message: FirebaseMessage) {
    const curatedMessagePartBodyTypes = ['new-expert-curated-order', 'new-system-curated-order']
    const richCardTypes = [MessageRichCardType.NEW_BOOKABLE_CURATED_ORDER]
    return (
      message.parts[0].type == 'TEMPLATE_CAROUSEL' &&
      (richCardTypes.includes(message.parts[0].body.richCardType) ||
        curatedMessagePartBodyTypes.includes(message.parts[0].body.type)) &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.expertCuratedOrderId
    )
  }

  public render() {
    const orderId = this.props.message.parts[0].body.queryVariables.expertCuratedOrderId

    return (
      <ExpertCuratedOrderRichCardComponent variables={{ id: orderId }}>
        {({ data, loading }) => {
          if (loading) {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Loading...
              </MessageBubbleText>
            )
          } else if (data && data.expertCuratedOrder) {
            const image = data.expertCuratedOrder.order.primaryImage
            const activeVariations = data.expertCuratedOrder.variationOptions.filter(
              variation => variation.enabled
            )

            const title = activeVariations[0].sellable.title
            const description = activeVariations[0].sellable.descriptionText

            return (
              <MessageBubble message={this.props.message}>
                <div className={styles.hero}>
                  {image && (
                    <Image
                      src={image.url}
                      width={384}
                      height={134}
                      imgixParams={{ fit: 'crop' }}
                      className={styles.heroImage}
                    />
                  )}
                </div>
                <div className={styles.content}>
                  <div className={styles.sellableTitle}>{title}</div>
                  {description && (
                    <div className={styles.description}>
                      {truncate(description, { length: 150 })}
                    </div>
                  )}
                  <div className={styles.variations}>
                    {activeVariations.map(variation => (
                      <div key={variation.sellable.id} className={styles.variant}>
                        {variation.sellable.variants[0] && (
                          <div className={styles.duration}>
                            {variation.sellable.variants[0].displayValueHtml}
                          </div>
                        )}
                        <div className={styles.price}>
                          {formatMonetaryAmountAsJsx(variation.price, { round: true })}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <Link to={`/curations/experiences/details/${orderId}`} className={styles.cta}>
                  View Order Details
                </Link>
              </MessageBubble>
            )
          } else {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Error loading messages!
              </MessageBubbleText>
            )
          }
        }}
      </ExpertCuratedOrderRichCardComponent>
    )
  }
}
